module.exports = __webpack_public_path__ + "static/media/minus-circle-solid.b19f8d31.svg";